import {Injectable} from '@angular/core';
import { StationLazyCategory } from '../../domain/infra/station/station';

@Injectable({
    providedIn: 'root'
})
export class StationUtilsService {

    public newChargeStationLazyCategories = [
        StationLazyCategory.USER_ACTIONS,
        StationLazyCategory.CURRENT_USER_ACTIONS,
        StationLazyCategory.PRICING_CONTEXT,
        StationLazyCategory.PLUG_TYPES,
        StationLazyCategory.OTP_ALLOWED_STATUSES
    ];

}
